import React from 'react';
import GrabArea from 'spw-static/images/grab-area.svg';

import { GripperWrapper } from './styles';

export const Gripper = ({
  isBottom = false,
  className = '',
  GrabIcon = GrabArea,
  wrapperStyles,
}: {
  isBottom?: boolean;
  className?: string;
  GrabIcon?: string;
  wrapperStyles?: React.CSSProperties;
}) => (
  <GripperWrapper
    style={wrapperStyles}
    $isBottom={isBottom}
    className={className}
  >
    <img src={GrabIcon} alt="grab location" />
  </GripperWrapper>
);
